import { createApi } from '@reduxjs/toolkit/query/react'
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import CONFIG from '../../app-configs'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'
import { type AuthenticationCheck, type LoginResponse, type LoginResult } from '../../api-schema-types/user/AuthDomainDtos'
import { type LoginPayload, type TwoFactorLoginPayload } from '../../api-schema-types/user/AuthPayloadDtos'

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/users`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResult, Partial<LoginPayload>>({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body
      })
    }),
    loginTwoFactor: builder.mutation<LoginResponse, TwoFactorLoginPayload>({
      query: (body) => ({
        url: '/auth/login/two-fa',
        method: 'POST',
        body
      })
    }),
    logout: builder.mutation<undefined, Partial<void>>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST'
      })
    }),
    checkAuthenticated: builder.mutation<AuthenticationCheck, Partial<void>>({
      query: () => ({
        url: '/auth/check',
        method: 'POST'
      })
    })
  })
})

export const useAuthLoginMutation = authenticationApi.endpoints.login.useMutation
export const useAuthLoginTwoFactorMutation = authenticationApi.endpoints.loginTwoFactor.useMutation
export const useAuthLogoutMutation = authenticationApi.endpoints.logout.useMutation
export const useAuthCheckAuthenticated = authenticationApi.endpoints.checkAuthenticated.useMutation
